import { render, staticRenderFns } from "./task-comment.vue?vue&type=template&id=27c9621c&"
import script from "./task-comment.vue?vue&type=script&lang=js&"
export * from "./task-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27c9621c')) {
      api.createRecord('27c9621c', component.options)
    } else {
      api.reload('27c9621c', component.options)
    }
    module.hot.accept("./task-comment.vue?vue&type=template&id=27c9621c&", function () {
      api.rerender('27c9621c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-comment.vue"
export default component.exports